/**
 * MobileResponsiveSpacing - Web app compliant values
 * Uses MUI theme spacing scale (8px base unit) for consistency with web app
 */

export const MobileSpacing = {
  // Container heights
  contentHeight: '717px', // 80vh of 896px - keep exact viewport height

  // Padding values - MUI theme spacing compliant
  containerPadding: '24px', // theme.spacing(3)
  containerPaddingTop: '24px', // theme.spacing(3)
  containerPaddingX: '24px', // theme.spacing(3)
  containerPaddingY: '16px', // theme.spacing(2)
  containerPaddingTopLarge: '32px', // theme.spacing(4)

  // Margins - MUI theme spacing compliant
  marginBottom: '8px', // theme.spacing(1)
  marginBottomMedium: '16px', // theme.spacing(2)
  marginBottomLarge: '32px', // theme.spacing(4)
  marginBottomXLarge: '80px', // theme.spacing(10)

  // Gaps - MUI theme spacing compliant
  gapSmall: '8px', // theme.spacing(1)
  gapMedium: '16px', // theme.spacing(2)
  gapLarge: '24px', // theme.spacing(3)
  gapXLarge: '32px', // theme.spacing(4)

  // Icon/avatar sizes - MUI theme spacing compliant
  iconSize: '24px', // theme.spacing(3)
  iconSizeSmall: '40px', // theme.spacing(5)
  avatarSize: '64px', // theme.spacing(8)

  // Typography - web app compliant
  fontSizeSmall: '12px', // Matches web app small text
  fontSizeMedium: '12px', // Matches web app small text
  fontSizeLarge: '14px', // Matches web app medium text
  fontSizeXLarge: '20px', // Matches web app large text

  // Layout dimensions - MUI theme spacing compliant
  minHeight: '48px', // theme.spacing(6)
  minWidth: '40px', // theme.spacing(5)
  minWidthMedium: '120px', // theme.spacing(15)
} as const;

export type MobileSpacingKey = keyof typeof MobileSpacing;
